import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as clients from '../../../../clients'
import * as proposal from '../proposal'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: proposal.RESOURCE.payload.dimension.partialId,
      partialId: proposal.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Client associated with the proposal',
    isOptional: true,
    name: 'Client',
    partialId: PartialId.Standard.create('client'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(clients.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
